import { render } from "./ProductCardSkeleton.vue?vue&type=template&id=5d479390&scoped=true"
import script from "./ProductCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductCardSkeleton.vue?vue&type=script&lang=js"

import "./ProductCardSkeleton.vue?vue&type=style&index=0&id=5d479390&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d479390"]])

export default __exports__